import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Datetime from 'react-datetime';
import 'moment-timezone';

import { ListDropdown, ListOpenDirections } from '@components/library/dropdown';

import 'react-datetime/css/react-datetime.css';
import './styles/date_time_picker.scss';

export default class DateTimePicker extends Component {
  constructor(props) {
    super(props);

    this.state = {
      timezoneArray: [],
      validDate: null
    };
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillMount() {
    const { allowPastDates } = this.props;

    const yesterday = moment().subtract(1, 'day');
    const validDate = allowPastDates ? () => true : (current) => current.isAfter(yesterday);
    const timezoneNames = moment.tz.names();
    const timezoneArray = timezoneNames.map((name) => ({ value: name, label: name }));

    this.setState({ validDate, timezoneArray });
  }

  handleUpdateDateTime(selectedDate, selectedTime, selectedZone) {
    const { updateDateTime } = this.props;

    // eslint-disable-next-line no-param-reassign
    selectedZone = selectedZone || moment.tz.guess();
    // TODO: figure out how to not log warnings about invalid moment objects.
    updateDateTime(selectedDate, selectedTime, selectedZone);
  }

  render() {
    const {
      displayCriterium,
      openDirection,
      selectedDate,
      selectedTime,
      selectedZone
    } = this.props;

    if (!displayCriterium) { return null; }

    const { validDate, timezoneArray } = this.state;

    return (
      <div className="date-time-picker-wrapper">
        <div className="date-picker-container picker-container">
          <label className="selection-label">
            {bfTranslate('Date')}
          </label>
          <Datetime
            className="t-date-selector"
            closeOnSelect
            inputProps={{ className: 'inputs' }}
            isValidDate={validDate}
            onChange={(date) => {
              this.handleUpdateDateTime(typeof date === 'string' ? date : date.format('MM/DD/YYYY'), selectedTime, selectedZone);
            }}
            timeFormat={false}
            utc
            value={selectedDate}
          />
          <span className="bff-calendar icon" />
        </div>
        <div className="time-picker-container picker-container">
          <label className="selection-label">
            {bfTranslate('Time')}
          </label>
          <Datetime
            closeOnSelect
            dateFormat={false}
            inputProps={{ className: 'inputs' }}
            isValidDate={validDate}
            onChange={(time) => {
              this.handleUpdateDateTime(selectedDate, typeof time === 'string' ? time : time.format('hh:mm a'), selectedZone);
            }}
            utc
            value={selectedTime}
          />
        </div>
        <div className="timezone-container select-wrapper picker-container">
          <label className="selection-label">
            {bfTranslate('Timezone')}
          </label>
          <ListDropdown
            id="date-time-picker-timezone"
            onChange={(timezone) => {
              this.handleUpdateDateTime(selectedDate, selectedTime, timezone ? timezone.value : timezone);
            }}
            openDirection={openDirection || ListOpenDirections.Down}
            options={timezoneArray}
            searchable
            value={selectedZone}
            virtualizeOptions
          />
        </div>
      </div>
    );
  }
}

DateTimePicker.propTypes = {
  allowPastDates: PropTypes.bool,
  displayCriterium: PropTypes.bool,
  openDirection: PropTypes.any,
  selectedDate: PropTypes.string,
  selectedTime: PropTypes.string,
  selectedZone: PropTypes.string,
  updateDateTime: PropTypes.func.isRequired
};

DateTimePicker.defaultProps = {
  allowPastDates: false,
  displayCriterium: true,
  openDirection: null,
  selectedDate: moment().format('MM/DD/YYYY'),
  selectedTime: moment().format('hh:mm a'),
  selectedZone: moment.tz.guess()
};
